(function() {
  "use strict";
  angular.module("marketPlace.sites", []);
})();
